
import Vue from 'vue';
import {
  mapState,
} from 'vuex';
import Card from '@/components/CardNew/index.vue';
import getTerritoryByAgentDocumentService, {
  TerritoryStatus,
} from '@/services/territory/get-territory-by-agent-document';
import { insertAppointment } from '@/services/appoinments/insert-appointment';
import Tag from '@/components/Tag/index.vue';
import { removeMaskDocument } from '@/utils';
import getTerritoryImgByCar from '@/services/territory/get-territory-img';
import authToken from '@/services/oauth/post-tmx-oauth';
import getActCurrent from '@/services/act/get-act-current';
import { Wrapper, Cards, Title } from './styles';

export default Vue.extend({
  components: {
    Wrapper,
    Cards,
    Title,
    Tag,
    Card,
  },
  data() {
    return {
      loading: false,
      territories: [] as any[],
      userLogged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      actDataResult: [] as any[],
      actData: {} as any,
      dataActData: [] as any,
    };
  },
  computed: {
    ...mapState(['appointments']),
  },
  methods: {
    onNavigationPush(item: any) {
      this.$router.push({ name: 'ProdDetails', params: { name: item.name, id: item.id } });
    },
    async fetchTerritoriesImg() {
      try {
        this.territories.forEach(async (territory, index) => {
          await new Promise((resolve) => setTimeout(resolve, 1000));
          const resp = await getActCurrent(this.userLogged.company.stKey, territory.id);
          if (resp.message === 'Encontrado.') {
            this.dataActData.push(resp.objectResult[resp.objectResult.length - 1]);
          }
          const imgUrl = await getTerritoryImgByCar((territory as any).geom);
          const territoryProp = territory;
          territoryProp.imageUrl = imgUrl;
          this.$set(this.territories, index, territoryProp);
        });
      } catch (error) {
        console.log('teste', error);
      }
    },
    async getTerritoryRequest() {
      await authToken();
      this.loading = true;

      const formattedValue = removeMaskDocument(this.userLogged.stDocument);
      this.territories = await getTerritoryByAgentDocumentService(
        formattedValue,
        '',
        TerritoryStatus.provisional,
        false,
      );
      this.fetchTerritoriesImg();
      this.loading = false;
      this.createAppointment('B', true);
    },
    createAppointment(score: string, quiz: boolean) {
      const { appointments } = this;
      this.territories.forEach((element: any) => {
        const hasAppointment = appointments.some((ap) => ap.cdTerritory === element.id);
        if (!hasAppointment) {
          const appointment = {
            agentId: element.agents[0].id,
            territoryId: element.id,
            appointmentType: 'AutoVistoria',
            url: 'www.teste.com',
            idUser: this.userLogged.idUser,
            tokenKey: this.userLogged.company.stKey,
            score,
            questionQuiz: quiz,
          };
          insertAppointment(appointment);
          appointment.appointmentType = 'GeoMonitoramento';
          insertAppointment(appointment);
        }
      });
    },
  },
  async mounted() {
    this.getTerritoryRequest();
    this.$toast.info('Olá produtor(a)! A plataforma Regenera está em atualização para melhor atendê-los e por isso algumas funções podem apresentar instabilidade. Caso precise de ajuda, entre em contato conosco pelo e-mail ajuda@agrotools.com.br ou pelo telefone +55 (12) 3913.5186. Contamos com a sua compreensão!', { timeout: 20000 });
  },
});
